import { useAuth } from "@/contexts/auth-context"
import { UserDisplay } from "@/components/user-display"
import { WalletConnectButton } from "@/components/WalletConnectButton"
import { cn } from "@/lib/utils"

export interface UserDisplayOrConnectButtonProps {
  /** When true, user trigger shows only the avatar. */
  avatarOnly?: boolean
  /** Class name for the trigger (user avatar button or connect button). */
  triggerClassName?: string
}

export function UserDisplayOrConnectButton({
  avatarOnly,
  triggerClassName,
}: UserDisplayOrConnectButtonProps = {}) {
  const { isVerified } = useAuth()

  if (isVerified)
    return (
      <UserDisplay
        avatarOnly={avatarOnly}
        triggerClassName={triggerClassName}
      />
    )

  return (
    <WalletConnectButton
      className={cn(
        avatarOnly &&
          "flex size-9 shrink-0 items-center justify-center rounded-full p-0 min-w-0",
        triggerClassName
      )}
    />
  )
}
